var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('content-editor',{attrs:{"permission":"branch","fields":_vm.fields,"endpoint":`structure/${_vm.$route.params.structure}/node`,"contentOptional":true,"canDelete":false,"canLock":false,"module":'structure'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }